var irreducible = require('./irreducible');
var isObject = require('./isObject');

module.exports = irreducible('Object', isObject);



//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/Object.js
// module id = 739
// module chunks = 114276838955818